import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  palette: {
    primary: {
      light: '#ffff8b',
      main: '#ffee58',
      dark: '#c9bc1f',
      contrastText: '#000000',
    },
    secondary: {
      light: '#f8bbd0',
      main: '#f8bbd0',
      dark: '#f8bbd0',
      contrastText: '#424242',
    },
  },
});
